import type { Component, ComponentUser } from '../../common/model/types.tsx';
import type {
	ComponentResponse,
	ComponentUser as ComponentUserResponse,
} from '../components/api-types';

const transformLead = (user: ComponentUserResponse, baseUrl: string): ComponentUser => ({
	displayName: user.displayName,
	key: user.key,
	active: user.active,
	accountId: user.accountId,
	avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
	// from PK - I could not see this code being used anywhere. Hence not updating to new url.
	profileUrl: `${baseUrl}/jira/people/${user.accountId}`,
});

export const transformComponentObj = (item: ComponentResponse, baseUrl: string): Component => {
	const { name, description, assigneeType, lead, componentBean } = item;
	const { ari, metadata } = componentBean ?? {};

	return {
		ari,
		metadata,
		name,
		description,
		issueCount: item.issueCount ? item.issueCount : 0,
		defaultAssignee: assigneeType,
		lead: lead ? transformLead(lead, baseUrl) : undefined,
	};
};
export const transformComponent = (
	item: ComponentResponse,
	baseUrl: string,
): {
	[key: string]: Component;
} => ({
	[item.id]: transformComponentObj(item, baseUrl),
});

export const transformComponents = (
	components: ComponentResponse[],
	total: number,
	baseUrl: string,
): {
	byId: {
		[key: string]: Component;
	};
	list: string[];
	listAri: string[];
	total: number;
} => {
	const list = components.map((i) => i.id);
	const listAri = components
		// Typesafe way to filter out undefined values.
		// Theoretically if global components are turned on, we will _only_ get back components with ARIs.
		// But to keep things happy with Typescript we need to handle undefined case as well.
		.flatMap(({ componentBean }) => (componentBean?.ari ? [componentBean?.ari] : []));

	const byId = Object.assign(
		{},
		...components.map((component) => transformComponent(component, baseUrl)),
	);

	return {
		byId,
		list,
		listAri,
		total,
	};
};
